import HttpClient from './utils/HttpClient';
import { pathName } from '../pathName';
import { ReqBodyType } from './types/reqBody';

interface UserServiceInterface {
  reqBody?: ReqBodyType;
  token: string;
}

class UserService {
  private readonly httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient(pathName);
  }

  getUserData = async({ token }: UserServiceInterface) => {
    return this.httpClient.get({
      path: '/user',
      token,
    });
  };

  changePassword = async({
    reqBody,
    token,
  }: UserServiceInterface) => {
    return this.httpClient.post({
      path: '/update-password',
      reqBody,
      token,
    });
  };

  editContactDetails = async({
    reqBody,
    token,
  }: UserServiceInterface) => {
    return this.httpClient.put({
      path: '/user',
      token,
      reqBody,
    });
  };
}

export default new UserService();
